import React from "react"

function Skeleton() {
  return (
    <div>
      <p className="placeholder-glow  mb-0">
        <span className="placeholder w-50"></span>
      </p>
      <p className="placeholder-wave mb-0">
        <span className="placeholder w-75"></span>
      </p>
      <p className="placeholder-wave mb-0">
        <span className="placeholder w-25"></span>
      </p>
    </div>
  )
}

export default Skeleton
